import { render, staticRenderFns } from "./SummaryFinance.vue?vue&type=template&id=10716f62&"
import script from "./SummaryFinance.vue?vue&type=script&lang=js&"
export * from "./SummaryFinance.vue?vue&type=script&lang=js&"
import style0 from "./SummaryFinance.vue?vue&type=style&index=0&id=10716f62&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports